import { lazy, Suspense, type ReactNode } from 'react';
import type { RouteObject } from 'react-router';
import { PageLoader } from '@dezza/ui';

const TermsPage = lazy(() => import('./TermsPage'));
const PrivacyPage = lazy(() => import('./PrivacyPage'));

const S = ({ children }: { children: ReactNode }) => <Suspense fallback={<PageLoader />}>{children}</Suspense>;

/** Termos de uso e Política de privacidade: públicos, fora do app logado, com ou sem sessão. */
export const publicRoutes: RouteObject[] = [
  { path: 'termos', element: <S><TermsPage /></S> },
  { path: 'privacidade', element: <S><PrivacyPage /></S> },
];
